import { activationDirection } from "./TabsRootDataAttributes.js";
const tabsStateAttributesMapping = {
  tabActivationDirection: (dir) => ({
    [activationDirection]: dir
  })
};
export {
  tabsStateAttributesMapping
};
//# sourceMappingURL=stateAttributesMapping.js.map
